var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgBook = function SvgBook(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 379.74 517.16",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#666;}.cls-2{fill:#fff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_2-2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 21.51,
    y: 17.73,
    width: 358.24,
    height: 499.43,
    rx: 4
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 12.28,
    y: 11.19,
    width: 358.24,
    height: 499.43,
    rx: 4
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 358.24,
    height: 499.43,
    rx: 4
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1.27,498.37l22,18.14-1.71-5.88L4.34,497.08Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer_4",
    "data-name": "Layer 4"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 142.44,
    y: 222.9,
    width: 80.32,
    height: 13.75
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 94.19,
    y: 151.23,
    width: 176.81,
    height: 15.88
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 64.61,
    y: 115.17,
    width: 229.03,
    height: 15.88
  })))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgBook, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/book.3d5ff7b1.svg";
export { ForwardRef as ReactComponent };